import { render, staticRenderFns } from "./BarChartBasic.vue?vue&type=template&id=12907989&"
import script from "./BarChartBasic.vue?vue&type=script&lang=js&"
export * from "./BarChartBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports